import { render, staticRenderFns } from "./TweetPolitik.vue?vue&type=template&id=5fbac14a&scoped=true"
import script from "./TweetPolitik.vue?vue&type=script&lang=ts"
export * from "./TweetPolitik.vue?vue&type=script&lang=ts"
import style0 from "./TweetPolitik.vue?vue&type=style&index=0&id=5fbac14a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbac14a",
  null
  
)

export default component.exports